import React, { forwardRef, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useI18n } from 'contexts/i18n'
import { format } from 'date-fns'
import { isofy } from 'utilities/date-time'
import { compact } from 'utilities/array'
import {
    LogEntry,
    AvatarWrapper,
    Content,
    ContentHeader, ContentHeaderTitle, Timestamp,
    Person,
    ContentBody
} from './s'
import Avatar from 'components/avatar'
import { Block as BlockCode } from 'components/code'
import { Plain } from 'components/button'
// import {
//     InfoCircleFilled as Info,
//     AlertTriangleFilled as Warning,
//     AlertOctagonFilled as Error
// } from 'components/feather'

const ActivityLogEntry = forwardRef(({ entry }, ref) => {
    const { dateLocale: locale } = useI18n()

    let {
        createdDate, // Example: 2024-08-28T08:53:25.905Z
        actor,
        type,
        resourceType,
        resourceId
    } = entry

    if(resourceId === 'null') {
        resourceId = ({
            USER: 'self'
        }[resourceType] ?? null)
    }

    const [showingDetails, setShowingDetails] = useState(false)

    // const Icon = levelToIconMap[level] ?? Error
    // const statusClassName = levelToClassNameMap[level] ?? 'failed'

    // user-identification-add
    // user-identification-remove
    // type of identification in params

    // user-update
    // user-import
    // Weird stuff in params: accepted: "[uuid]", rejected: "0", duplicates: "1"

    return (
        <LogEntry ref={ref}>
            <AvatarWrapper>
                <Avatar
                    who={actor}
                    size={20} />
            </AvatarWrapper>
            <Content>
                <ContentHeader>
                    <ContentHeaderTitle className="compact">
                        {compact([type, resourceId]).join(' on ')}
                    </ContentHeaderTitle>
                    {/* <StatusLabel className={statusClassName}>{level}</StatusLabel> */}
                    <Timestamp dateTime={createdDate}>
                        {format(isofy(createdDate), 'pp', { locale })}
                    </Timestamp>
                </ContentHeader>
                <div>
                    {!!showingDetails && (
                        <ContentBody>
                            <h3>Log entry:</h3>
                            <Person
                                who={actor}
                                size={16}
                                asLink={true} />
                            <BlockCode
                                language="properties"
                                wrapLongLines={true}
                                code={formatObject(entry)} />
                        </ContentBody>
                    )}
                    <Plain
                        onClick={() => setShowingDetails(!showingDetails)}
                        className="constructive">
                        <FormattedMessage
                            id={!!showingDetails ?
                                'action_hide_details' :
                                'action_show_details'
                            }
                            defaultMessage={!!showingDetails ?
                                'Hide details' :
                                'Show details'
                            } />
                    </Plain>
                </div>
            </Content>
            <Timestamp dateTime={createdDate}>
                {format(isofy(createdDate), 'pp', { locale })}
            </Timestamp>
        </LogEntry>
    )
})

const formatObject = object => {
    if(!object) {
        return ''
    }

    const jsonString = JSON.stringify(object, null, 4)
    const formattedString = jsonString
        .replace(/"([^"]+)":/g, '$1:') // Remove all quotes around keys
        .replace(/^\s*{\n/, '') // Remove opening curly brace and newline
        .replace(/\n\s*}\s*$/, '') // Remove closing curly brace and surrounding whitespace
        .replace(/\n\s\s\s\s/g, '\n') // Remove indentation and replace with newline
        .replace(/^\s\s\s\s/, '') // Remove indentation from first line

    return formattedString
}

// const levelToIconMap = {
//     ERROR: Error,
//     WARNING: Warning,
//     INFO: Info
// }
//
// const levelToClassNameMap = {
//     ERROR: 'failed',
//     WARNING: 'passive',
//     INFO: 'positive'
// }

export default ActivityLogEntry